import { createEvent } from './create-event'

export interface StorageChangeEvent {
  key: string
  newValue: string | null
  storage: Storage
}

export const storageChangeEvent =
  createEvent<StorageChangeEvent>('storage-change')

export class InMemoryLocalStorage implements Storage {
  private store = new Map<string, string>()

  get length(): number {
    return this.store.size
  }

  key(index: number): string | null {
    const keys = Array.from(this.store.keys())
    return keys[index] ?? null
  }

  getItem(key: string): string | null {
    return this.store.get(key) ?? null
  }

  setItem(key: string, value: string): void {
    this.store.set(key, value)
    storageChangeEvent.emit({ key, newValue: value, storage: this })
  }

  removeItem(key: string): void {
    this.store.delete(key)
    storageChangeEvent.emit({ key, newValue: null, storage: this })
  }

  clear(): void {
    this.store.clear()
  }
}
